import { useState, useEffect } from 'react';
import jwt_decode from 'jwt-decode';
import { useAuth0 } from '@auth0/auth0-react';
import {
  PrimaryButton,
  Spinner,
  SpinnerSize,
  Stack,
  StackItem,
} from '@fluentui/react';
import { useAppSelector } from '../../redux/hooks';
import { getPermissions } from '../../redux/permission/permissionSlice';

interface ISaveButtonWithPermissions {
  permission: string;
  disabled?: boolean;
  save?: () => void | Promise<unknown>;
  loading?: boolean;
  text?: string;
  color?: string;
}

const SaveButtonWithPermissions = ({
  permission,
  disabled = false,
  save,
  loading = false,
  text,
  color,
}: ISaveButtonWithPermissions) => {
  const permissions = useAppSelector(getPermissions);
  const [busy, setBusy] = useState(false);

  /**
   * Blokkeert de knop zolang de actie loopt wanneer `save` een belofte teruggeeft.
   * Zonder dit bleef de knop klikbaar tijdens het versturen van een mail, en
   * vuurde elke klik een nieuw verzoek af (waargenomen: 7 pogingen in 4 minuten
   * omdat er niets zichtbaar gebeurde).
   */
  const handleClick = async () => {
    if (!save || busy) return;
    try {
      setBusy(true);
      await save();
    } finally {
      setBusy(false);
    }
  };

  return (
    <StackItem>
      {permissions.includes(permission) && (
        <StackItem>
          <PrimaryButton
            onClick={handleClick}
            style={{ marginRight: 10, backgroundColor: color, borderColor: color }}
            disabled={disabled || busy}
          >
            {text ? (
              <span>{text}</span>
            )
          : (<span>Opslaan</span>)}
            {(loading || busy) && (
              <Stack>
                <Spinner size={SpinnerSize.small} />
              </Stack>
            )}
          </PrimaryButton>
        </StackItem>
      )}
    </StackItem>
  );
};

export default SaveButtonWithPermissions;
